module.exports = __webpack_public_path__ + "img/Avatar2@2x.9d977670.png";